import { motion } from 'motion/react';

type Props = {
  size?: number;
};

export const EndOfFaxesGraphic = ({ size = 1000 }: Props) => (
  <motion.svg
    xmlns='http://www.w3.org/2000/svg'
    id='Layer_1'
    viewBox='0 0 355.25 349.34'
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    css={{
      height: size,
      width: size,
      '.b': {
        stroke: '#6ba6ff',
      },

      '.b, .c, .d': {
        fill: 'none',
        strokeLinecap: 'round',
        strokeMiterlimit: '3',
      },

      '.b, .d': {
        strokeWidth: '6px',
      },

      '.c': {
        stroke: '#dcebfe',
        strokeWidth: '5px',
      },

      '.d': {
        stroke: '#9aede6',
      },

      '.e': {
        fill: '#9aede6',
      },

      '.e, .f, .g, .h, .i, .j, .k, .l': {
        strokeWidth: '0px',
      },

      '.f': {
        fill: '#3f8bfd',
      },

      '.g': {
        fill: '#c2f4f1',
      },

      '.h': {
        fill: '#dcebfe',
      },

      '.i': {
        fill: '#6ba6ff',
      },

      '.j': {
        fill: '#9ec5ff',
      },

      '.k': {
        fill: '#fff',
      },

      '.l': {
        fill: '#ebf3ff',
      },
    }}
  >
    <circle className='l' cx='176.85' cy='186.84' r='162.5' />
    <path
      className='j'
      d='M229.3,62.54l15.3,15.3c1.06,1.06,2.77,1.06,3.83,0s1.06-2.77,0-3.83l-15.3-15.3c-1.06-1.06-2.77-1.06-3.83,0s-1.06,2.77,0,3.83Z'
    />
    <path
      className='j'
      d='M229.3,77.84c1.06,1.06,2.77,1.06,3.83,0l15.3-15.3c1.06-1.06,1.06-2.77,0-3.83-1.06-1.06-2.77-1.06-3.83,0l-15.3,15.3c-1.06,1.06-1.06,2.77,0,3.83Z'
    />
    <path
      className='j'
      d='M196.53,302.92l8.79,8.79c.61.61,1.59.61,2.2,0s.61-1.59,0-2.2l-8.79-8.79c-.61-.61-1.59-.61-2.2,0s-.61,1.59,0,2.2Z'
    />
    <path
      className='j'
      d='M196.53,311.7c.61.61,1.59.61,2.2,0l8.79-8.79c.61-.61.61-1.59,0-2.2s-1.59-.61-2.2,0l-8.79,8.79c-.61.61-.61,1.59,0,2.2Z'
    />
    <path
      className='h'
      d='M343.82,100.19l8.79,8.79c.61.61,1.59.61,2.2,0s.61-1.59,0-2.2l-8.79-8.79c-.61-.61-1.59-.61-2.2,0s-.61,1.59,0,2.2Z'
    />
    <path
      className='h'
      d='M343.82,108.97c.61.61,1.59.61,2.2,0l8.79-8.79c.61-.61.61-1.59,0-2.2s-1.59-.61-2.2,0l-8.79,8.79c-.61.61-.61,1.59,0,2.2Z'
    />
    <path
      className='h'
      d='M133.4,2.65l8.79,8.79c.61.61,1.59.61,2.2,0s.61-1.59,0-2.2L135.6.45c-.61-.61-1.59-.61-2.2,0s-.61,1.59,0,2.2Z'
    />
    <path
      className='h'
      d='M133.4,11.44c.61.61,1.59.61,2.2,0l8.79-8.79c.61-.61.61-1.59,0-2.2s-1.59-.61-2.2,0l-8.79,8.79c-.61.61-.61,1.59,0,2.2Z'
    />
    <rect className='k' x='183.48' y='114.07' width='118.2' height='151.32' rx='10.21' ry='10.21' />
    <line className='c' x1='178.74' y1='170.97' x2='279.32' y2='170.97' />
    <line className='c' x1='204.82' y1='152.29' x2='257.12' y2='152.29' />
    <line className='c' x1='178.74' y1='188.86' x2='279.32' y2='188.86' />
    <line className='c' x1='178.74' y1='206.74' x2='279.32' y2='206.74' />
    <line className='c' x1='178.74' y1='224.62' x2='279.32' y2='224.62' />
    <line className='c' x1='178.74' y1='242.5' x2='279.32' y2='242.5' />
    <path className='h' d='M301.68,139.07h-20c-2.76,0-5-2.24-5-5v-20s25,25,25,25Z' />
    <rect className='g' x='102.19' y='94.55' width='146.92' height='188.08' rx='12.68' ry='12.68' />
    <line className='d' x1='104.96' y1='165.25' x2='226.23' y2='165.25' />
    <line className='d' x1='136.41' y1='142.73' x2='199.46' y2='142.73' />
    <line className='d' x1='104.96' y1='186.81' x2='226.23' y2='186.81' />
    <line className='d' x1='104.96' y1='208.37' x2='226.23' y2='208.37' />
    <line className='d' x1='104.96' y1='229.93' x2='226.23' y2='229.93' />
    <line className='d' x1='104.96' y1='251.49' x2='226.23' y2='251.49' />
    <path
      className='j'
      d='M162.63,300.84H15.37c-8.49,0-15.37-6.88-15.37-15.37V88.34c0-8.49,6.88-15.37,15.37-15.37h122.63l40,40v172.5c0,8.49-6.88,15.37-15.37,15.37Z'
    />
    <circle className='k' cx='89.11' cy='154.34' r='52.72' />
    <path
      className='f'
      d='M114.69,138.86l-41.05,41.05c-2.83,2.83-7.39,2.87-10.18.08-2.79-2.79-2.75-7.35.08-10.18l41.05-41.05c2.83-2.83,7.39-2.87,10.18-.08,2.79,2.79,2.75,7.35-.08,10.18Z'
    />
    <path
      className='f'
      d='M114.36,179.59c-2.83,2.83-7.39,2.87-10.18.08l-40.4-40.4c-2.79-2.79-2.75-7.35.08-10.18,2.83-2.83,7.39-2.87,10.18-.08l40.4,40.4c2.79,2.79,2.75,7.35-.08,10.18Z'
    />
    <path className='i' d='M177.99,112.97h-32c-4.42,0-8-3.58-8-8v-32s40,40,40,40Z' />
    <line className='b' x1='29.8' y1='228.08' x2='92.85' y2='228.08' />
    <line className='b' x1='29.8' y1='251.68' x2='151.07' y2='251.68' />
    <line className='b' x1='29.8' y1='275.28' x2='151.07' y2='275.28' />
    <path className='e' d='M249.11,124.55h-24c-3.31,0-6-2.69-6-6v-24s30,30,30,30Z' />
  </motion.svg>
);
